import { validate } from './validations'
import { build } from '../../services/crudFactory'
import { Action } from '../../services/actions.factory'
import { actions as grupoActions } from '../grupo/grupo.actions'
import utils from '../../utils'
const BASE_PATH = '/lottustech/gruposfinanceiros'
const crud = build(validate, BASE_PATH)
const prefix = 'crudGrupo'

const newTypes = {
  SET_BOOLEAN_FILTER: `${prefix}setBooleanFilter`,
  SET_LOOKUP_GRUPO_VISIBLE: `${prefix}setLookupGrupoVisible`,
  PICKLIST_PERFIS_MOVE_TO_TARGET: `${prefix}pickListPerfisMoveToTarget`,
  PICKLIST_PERFIS_MOVE_TO_SOURCE: `${prefix}pickListPerfisMoveToSource`,
  PICKLIST_PERFIS_MOVE_ALL_TO_SOURCE: `${prefix}pickListPerfisMoveAllToSource`,
  PICKLIST_PERFIS_MOVE_ALL_TO_TARGET: `${prefix}pickListPerfisMoveAllToTarget`,
  RESET: `${prefix}reset`,
}

const actions = new Action(prefix, crud)
const types = Object.assign({}, actions.types, newTypes)

actions.setBooleanFilter = (field, value) => {
  return {
    type: types.SET_BOOLEAN_FILTER,
    field,
    value,
  }
}

actions.setLookupGrupoVisible = (visible) => {
  return {
    type: types.SET_LOOKUP_GRUPO_VISIBLE,
    visible,
  }
}

actions.reset = () => {
  return {
    type: types.RESET,
  }
}

actions.aplicarFiltrosDadosGrupo = (filterParams) => {
  return (dispatch, getState) => {
    const state = getState()[`crudTaxaState`]
    let record = state.currentRecord
    if (utils.nonNull(filterParams)) {
      dispatch(grupoActions.setSelectedFilters(filterParams.campo, filterParams.valor, null, null))
    }

    if (record.unidade && record.unidade.id) {
      const filtro = {
        campo: 'oid',
        valor: record.unidade.id,
        tipoFiltro: 'IGUAL_A',
        fieldJoin: 'oid',
        relacionamento: ['unidade'],
      }
      dispatch(grupoActions.setFiltroAvancado(filtro))
    }
    dispatch(grupoActions.loadLookup())
  }
}

actions.pickListPerfisMoveToSource = (perfisRemoved) => {
  return {
    type: types.PICKLIST_PERFIS_MOVE_TO_SOURCE,
    perfisRemoved,
  }
}

actions.pickListPerfisMoveAllToSource = (perfisRemoved) => {
  return {
    type: types.PICKLIST_PERFIS_MOVE_ALL_TO_SOURCE,
  }
}

actions.pickListPerfisMoveToTarget = (perfisAdd, oid) => {
  return {
    type: types.PICKLIST_PERFIS_MOVE_TO_TARGET,
    perfisAdd,
    oid,
  }
}

actions.pickListPerfisMoveAllToTarget = (allPerfis, oid) => {
  return actions.pickListPerfisMoveToTarget(allPerfis, oid)
}

export { types, actions }
